import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  constructor(public sv: AppService,
    private http: HttpClient) {
    this.getProfile();

  }
  profile: any;
  contact: boolean = false;
  viewContact() {
    this.contact = !this.contact
    this.profile.view = !this.profile.view
  }

  getProfile() {
    this.http.get("Profile").subscribe({
      next: (res: any) => {
        this.profile = res.data
        this.profile.view = false
      }
    })
  }

  closeProfile() {
    this.profile.view = false;
  }
}
